import { NgModule } from "@angular/core";
import { CurrencyFormatterPipe } from "./currency-formatter/currency-formatter.pipe";
import { FilterKeywordsPipe } from "./filter-keywords";
import { FilterDataPipe } from "./filter-data.pipe";
import { HighlightSearchPipe } from "./highlight-search.pipe";
import { TruncateTextPipe } from "./truncatetext/truncatetext.pipe";
import { FormatPhoneNumberPipe, SafeFormatPhoneNumberPipe } from "./format-phone-number/format-phone-number.pipe";
import { SafeurlPipe } from "./safeurl/safeurl.pipe";
import { DateFormatPipe } from './date-format/date-format.pipe';
import { MinutesToTimePipe } from "./minutes-to-time.pipe";
import { SentenceCasePipe } from "./sentence-case.pipe";


@NgModule({
    imports: [
        CurrencyFormatterPipe,
        SafeurlPipe,
    ],
    declarations: [
        FormatPhoneNumberPipe,
        SafeFormatPhoneNumberPipe,
        FilterDataPipe,
        MinutesToTimePipe,
        HighlightSearchPipe,
        FilterDataPipe,
        TruncateTextPipe,
        FilterKeywordsPipe,
        DateFormatPipe,
        SentenceCasePipe

    ],
    exports: [
        CurrencyFormatterPipe,
        FormatPhoneNumberPipe,
        SafeFormatPhoneNumberPipe,
        SafeurlPipe,
        FilterDataPipe,
        HighlightSearchPipe,
        FilterDataPipe,
        TruncateTextPipe,
        FilterKeywordsPipe,
        DateFormatPipe,
        MinutesToTimePipe,
        SentenceCasePipe
    ]
})

export class PipesModule { }
